// Basic
import { useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import useSessionStore from '@/app/store/session';
// Components
import Dropdown from '@/common-utils/components/renders/dropdown/Dropdown';
import ModalHistoricsDetails from '../modals/ModalHistoricsDetails';
// Common
import ICONS from '@/common-utils/enums/icons';
import Permissions from '@/app/permissions/Permissions';
// Lang
import { nsHistorics } from '@/app/i18n/namespaces';
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';

/**
 *
 * @param root0
 * @param root0.historics
 * @param root0.actions
 * @returns {JSX} DropdownHistoricsActionsRow
 */
function DropdownHistoricsActionsRow({ historics, actions }) {
    // Store
    const session = useSessionStore(s => s.session);
    const permissions = session.permissions;

    //State
    const [showModalHistoricsDetails, setShowModalHistoricsDetails] = useState(false);


    return (
        <>
            <Dropdown
                triggerValues={{ variant: 'ghostNoBorder', icon: ICONS.MORE }}
                actions={[
                    {
                        icon: ICONS.TAB,
                        entity: 'actions.row.details',
                        namespace: nsHistorics,
                        onClick: () => setShowModalHistoricsDetails(true),
                        visible: true,
                        disabled: !hasRequiredPermissions({
                            permissions: permissions,
                            requiredPermissions: [Permissions.LIST_HISTORY.name]
                        }),
                        tooltipForbidden: 'title.permissions.access_denied'
                    }
                ]} />
            {
                showModalHistoricsDetails &&
                <ModalHistoricsDetails
                    isOpen={showModalHistoricsDetails}
                    setIsOpen={setShowModalHistoricsDetails}
                    historics={historics}
                    actions={actions}
                />
            }
        </>
    );
}

DropdownHistoricsActionsRow.propTypes = {
    historics: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

export default DropdownHistoricsActionsRow;